module.exports = __webpack_public_path__ + "static/media/William_Sutton_Resume().b51ec8cd.pdf";